import { SearchProvider } from '@cast/shared-search-ui';
import { CostReportProvider } from '@cast/split-me/features/cost-report';
import {
  GpuUtilizationTable,
  useGpuUtilizationSearchCriteria,
  useGpuUtilizationSummaryData,
} from '@cast/split-me/features/cluster/cost-report';
import { WORKLOAD_CATEGORIES } from '../../../_constants';
import { useInventoryMonitoringWorkloadLink } from '../../../_hooks/useInventoryMonitoringWorkloadLink';
import { inventoryWorkloadsTableKeys, tableCacheKeys } from '../../../consts';

const GpuContent = () => {
  const criteria = useGpuUtilizationSearchCriteria();
  const getWorkloadLink = useInventoryMonitoringWorkloadLink(
    WORKLOAD_CATEGORIES.GPU_UTILIZATION
  );

  return (
    <SearchProvider
      criteria={criteria}
      useData={useGpuUtilizationSummaryData}
      urlKey={inventoryWorkloadsTableKeys.GPU_UTILIZATION}
      serverSideSort
      disableFreeText
    >
      <GpuUtilizationTable
        cacheKey={tableCacheKeys.INVENTORY_WORKLOADS.GPU_UTILIZATION}
        getWorkloadLink={({ namespace, workloadName, workloadType }) =>
          getWorkloadLink({
            namespace,
            workloadName,
            workloadType,
          })
        }
        filtersSize="small"
      />
    </SearchProvider>
  );
};

export const InventoryWorkloadsListGpu = () => (
  <CostReportProvider>
    <GpuContent />
  </CostReportProvider>
);
